import { render, staticRenderFns } from "./GeoImages.page.vue?vue&type=template&id=556cf2fc&scoped=true"
import script from "./GeoImages.page.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeoImages.page.vue?vue&type=script&setup=true&lang=ts"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=556cf2fc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556cf2fc",
  null
  
)

export default component.exports